
import { Vue, Component, Prop, Model, Watch, Mixins } from 'vue-property-decorator'
import * as T from '@/types'
import S from '@/store'

import InputEntityMixin from '@/mixins/mixin-input-entity.tsx'

@Component
export default class InputSource extends Mixins<InputEntityMixin<T.Source>>(InputEntityMixin) {

    @Prop({ type: Boolean, default: false }) allowAny!: boolean
    @S.Sources.Getter all!: T.Source[]

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get singularDisplayName () { return 'source' }
    get pluralDisplayName () { return 'sources' }
    get deactivatable () { return true }

    get scopedSlots () { return {text: (scope: { option: T.Source }) => <span>{this.getSourceName (scope.option)}</span> }}

    get entities () {
        if (this.allowAny){
            let newEntities = [...this.all]
            newEntities.unshift({
                source: 'Any',
                name: 'Any',
                id: '',
                createdAt: '',
                updatedAt: '',
            })
            return newEntities
        } 
        return this.all
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    getSourceName (source: T.Source) {
        return source && source.name
    }

    getOptionValue (source: T.Source) { return this.getSourceName(source) }
    getOptionFilterKey (source: T.Source) { return this.getSourceName(source) }
    getOptionTitle (source: T.Source) { return this.getSourceName(source) }
    isOptionArchived (source: T.Source) { return false }
    
}
